module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAD4CAYAAAAtiIxYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACBSURBVHgBpVJBDsAgCCv+/82yuIMEAlqiB8NKgVIHrKOqMlawL9lXwLKsdMpCNDyZzUq7ohR+3jxk//bqeZJguHcmnHyxHYlI3KXZMoOsKB/ALAmYdZl+pGGBXEahX/Z5xloz1MtltWhFIXjZyJZ6kNJwX3qS7p59Jl6BEJ7+KnY+NNhH5yOHg4MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/axj_web/axj_web_body_line.png
// module id = TwAE
// module chunks = 1